"use client";

import { useEffect, useRef } from "react";
import TopupFilters from "./TopupFilters";
import PiBotLoader from "@/components/PiBotLoader.jsx";

export default function TopupFilterDrawer({
  isOpen,
  onClose,
  filters,
  setFilters,
  filterOptions,
  onReset,
  isLoading, // ✅ add
}) {

  const panelRef = useRef(null);

  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  // Lock body scroll when open
  useEffect(() => {
    if (!isOpen) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev || "";
    };
  }, [isOpen]);

  // Click outside to close
  const handleOverlayClick = (e) => {
    if (!panelRef.current) return;
    if (!panelRef.current.contains(e.target)) onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-[1px]"
      onMouseDown={handleOverlayClick}
      aria-modal="true"
      role="dialog"
      aria-label="Topup filters"
    >
      <div
        ref={panelRef}
        className="
          fixed right-0 top-0 h-full w-[86%] max-w-sm
          bg-surface border-l border-border shadow-xl
          flex flex-col
          animate-[slideIn_.2s_ease-out]
        "
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h2 className="text-sm font-semibold text-textPrimary">Topup Filters</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-xl leading-none text-textPrimary hover:text-accent"
            aria-label="Close filters"
          >
            &times;
          </button>
        </div>

       <div className="p-4 overflow-y-auto">
  {isLoading ? (
    <div className="flex flex-col items-center justify-center py-10">
      <PiBotLoader size={72} label="Loading filters…" />
      <p className="mt-2 text-xs text-textSecondary text-center">
        Preparing countries & regions…
      </p>
    </div>
  ) : (
    <TopupFilters
      filters={filters}
      options={filterOptions}
      onChange={(key, value) => {
        if (key === "country") {
          setFilters({ country: value, brand: "", region: "", subType: "" });
        } else {
          setFilters((prev) => ({ ...prev, [key]: value }));
        }
        setPage(1); // ← add this
      }}
    />
  )}
</div>


        <div className="mt-auto px-4 py-3 border-t border-border flex items-center justify-between">
        <button
  type="button"
  onClick={() => onReset?.()}
  disabled={isLoading}
  className="text-sm underline text-textSecondary hover:text-textPrimary disabled:opacity-60"
>
  Reset
</button>

<button
  type="button"
  onClick={onClose}
  disabled={isLoading}
  className="px-4 py-2 rounded-md bg-primary text-white text-sm font-medium hover:opacity-90 disabled:opacity-60"
>
  Apply
</button>

        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from { transform: translateX(16px); opacity: .85; }
          to   { transform: translateX(0);     opacity: 1; }
        }
      `}</style>
    </div>
  );
}
